"use client"

import { useMemo, useState, useEffect } from "react"

const EXT_SWAPS = {
  ".png": [".jpg", ".jpeg", ".webp"],
  ".jpg": [".png", ".jpeg", ".webp"],
  ".jpeg": [".png", ".jpg", ".webp"],
  ".webp": [".png", ".jpg", ".jpeg"],
}

function extOf(src) {
  const m = src.match(/\.(png|jpe?g|webp)$/i)
  return m ? "." + m[1].toLowerCase().replace("jpeg", "jpeg") : ""
}

function withExt(src, newExt) {
  return src.replace(/\.(png|jpe?g|webp)$/i, newExt)
}

function buildCandidates(src) {
  if (!src) return []
  const seen = new Set()
  const out = []
  const push = (v) => {
    if (v && !seen.has(v)) {
      seen.add(v)
      out.push(v)
    }
  }

  push(src)

  const ext = extOf(src)
  if (ext && EXT_SWAPS[ext]) {
    for (const alt of EXT_SWAPS[ext]) push(withExt(src, alt))
  }

  const variants = [...out]
  for (const v of variants) {
    if (v.startsWith("/images/") && !v.startsWith("/images/chennai/")) {
      push(v.replace("/images/", "/images/chennai/"))
    }
  }

  return out
}

export function FallbackImage({ src, alt = "", className = "", fallback = "/placeholder.svg", ...rest }) {
  const candidates = useMemo(() => buildCandidates(src), [src])
  const [idx, setIdx] = useState(0)

  useEffect(() => {
    setIdx(0)
  }, [src])

  const current = candidates[idx] || fallback

  const handleError = () => {
    if (idx < candidates.length - 1) {
      setIdx(idx + 1)
    } else if (current !== fallback) {
      setIdx(candidates.length)
    }
  }

  return (
    <img
      src={current}
      alt={alt}
      className={className}
      onError={handleError}
      {...rest}
    />
  )
}
